import { formatAmount } from '@utils'; 

export const PaymentAmount = ({ amount }) => <div className="py-8 border-b border-zinc-200 text-center lg:text-start">
  <h2 className="font-semibold mb-1">Payment amount</h2>
  <h1 className="font-medium text-4xl">{formatAmount(amount)}</h1>
</div>